// Sessions
export const SESSION_SET_LOGIN = 'SESSION:SET_LOGIN'
export const SESSION_SET_PAYMENT = 'SESSION:SET_PAYMENT'
export const SESSION_PURGE_AUTH = 'SESSION:PURGE_AUTH'
export const SESSION_ADD_CARD = 'SESSION:ADD_CARD'
export const SESSION_SET_NEW_PLAN_DATA = 'SESSION:SET_NEW_PLAN_DATA'
export const SESSION_ADD_PAYMENT = 'SESSION:ADD_PAYMENT'
